import React, { useEffect, useRef } from 'react'
import { useNetworkStatus } from '@dostavkee/react-hooks'
import { Id, toast } from 'react-toastify'

const NetworkOfflineToast = () => (
    <section>
        <strong>Проблемы с интернетом</strong>
        <div>Пожалуйста, проверьте ваше соединение</div>
    </section>
)

export function NetworkStatus() {
    const { isOffline, isOnline } = useNetworkStatus()

    const toastIdRef = useRef<Id | undefined>()

    /**
     * Показываем toast, если интернет пропал
     */
    useEffect(() => {
        if (isOffline) {
            toastIdRef.current = toast.warn(<NetworkOfflineToast />, { isLoading: true })
        }
    }, [isOffline])

    /**
     * Скрываем toast, если интернет восстановился
     */
    useEffect(() => {
        if (isOnline && toastIdRef.current) {
            toastIdRef.current = undefined

            /**
             * Если ранее был показан toast, то скрываем его
             */
            toast.dismiss(toastIdRef.current)
        }
    }, [isOnline])

    return null
}
